<template>
    <div class="planbord-grid-row" :class="{sticky}">
        <slot></slot>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class PlanbordGridRow extends Vue {
        @Prop({type: Boolean}) public sticky!: boolean;
    }
</script>

<style lang="scss" scoped>
    .planbord-grid-row {
        display: grid;
        grid-column: 1 / -1;
        grid-template-columns: subgrid;

        &:first-child {
            border-top: 1px solid var(--cell-border-color);
        }

        &.sticky {
            position: sticky;
            top: 0;
            z-index: 99;
        }
    }
</style>
